import PriceBoostPageView from './price-boost-page-view/index.jsx';

export default function PriceBoostPage() {
    return <PriceBoostPageView />;
}
